import { useEffect, useState } from 'react';

const useSizing = (myRef) => {
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const [intervalId, setIntervalId] = useState(null);

  const handleResize = () => {
    if (myRef && myRef.current) {
      setWidth(myRef.current.offsetWidth);
      setHeight(myRef.current.offsetHeight);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleResize();
    }, 200);
    setIntervalId(intervalId);
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  useEffect(() => {
    if (height !== null && width !== null) {
      if (intervalId) {
        clearInterval(intervalId);
        setIntervalId(null);
      }
    }
  }, [height, width]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [myRef]);

  return { width: width || 0, height: height || 0 };
};

export default useSizing;
